<template>
  <header class="w-full flex justify-center" :class="{ 'border-b border-black': withBorder }">
    <section
      class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12 gap-x-4 md:gap-x-6 px-4 lg:px-6"
    >
      <section
        class="flex justify-center lg:justify-between items-center col-span-full md:col-start-2 md:col-end-8 lg:col-end-12 p-2.5"
      >
        <section class="flex items-center gap-x-4">
          <span class="w-12 h-12 bg-gray-400 rounded-lg" />
          <p class="text-3xl" v-text="'Main logo'" />
        </section>
        <section v-if="!isMobile">
          Something else
        </section>
      </section>
    </section>
  </header>
</template>
<script>
import utilsMixin from "../mixins/utilsMixin";
export default {
  mixins: [utilsMixin],
  props:{
    withBorder:{
      default: true
    }
  }
};
</script>
